import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import {NavLink as RouterLink} from 'react-router-dom';
import { Paper, Box, Typography, Divider, List,  ListItem, ListItemButton,ListItemText } from '@mui/material';
import { treeDeparts } from '../../modules/deptModule/departs';



const AuthDepartsContainer = () => {
    const dispatch = useDispatch();
    

    const [authDeparts, setAuthDeparts] = useState(null)

    const { departs, error, loading } = useSelector(
        ({ departModule, loading }) => ({
            departs: departModule.departs.departs,
            error: departModule.departs.error,
            loading: loading['depart/TREE_DEPART'],
        }),
    );

   

    useEffect(() => {
        if (!departs) {
            dispatch(treeDeparts());
        }

    }, [departs, dispatch]);

    useEffect(() => {
        if (departs?.children) {
            const filteredDeaprt = _.filter(departs?.children, (depart) => depart.Level === "1");
            setAuthDeparts(filteredDeaprt);
        }

    }, [departs])

    if (error) {
        return <div>에러가 발생하였습니다. 관리자에게 문의하여 주십시오.</div>
    }

    if (loading || !departs) {
        return null;
    }

    return (
        <Paper>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    backgroundColor: '#424242',
                    color: '#fff',
                    py: 1,
                    px:2
                }}
            >
                {/* <Box sx={{ mx: 2 }}>
                    <AccountTreeIcon />
                </Box> */}
                <Typography variant="subtitle2" component="div">
                    총괄 부서 리스트
                </Typography>
            </Box>
            <Divider />

            <Box sx={{
               width:'360px'
                
            }}>
                <List sx={{ width: '100%' , bgcolor: 'background.paper'}}>
                    {authDeparts && authDeparts.map((depart, index) => (
                        <ListItem key={index} dense divider={index === authDeparts.length - 1 ? false : true} >
                            <ListItemButton
                                component={RouterLink}
                                to={`/authmenumng/${depart.id}`}
                                end
                                style={({ isActive }) => ({ background: isActive ? '#1769aa' : '', color: isActive ? '#fff' : '' })}
                              
                            >

                                <ListItemText primary={<Typography variant="body2" component="div">{depart.name}</Typography>} />
                            </ListItemButton>
                        </ListItem>

                    ))}
                </List>
            </Box>
        </Paper>
    )
}

export default AuthDepartsContainer